<template>
    <div class="col-12">
        <v-card
            class="text-center"
            :style="'border-color:' + primaryColor + '!important'"
            id="empty-opening-period">
            <div class="d-inline-block w-100 room-card-box">
                <v-btn
                       text
                       :color="primaryColor"
                       class="add-period-btn"
                       @click="openModal()">
                    <v-icon :color="primaryColor" left>add</v-icon>
                    Ajouter une période d'ouverture
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"

export default {
    name: "AddButton",
    data() {
        return {
            initPeriod: {
                valid_from: null,
                valid_through: null,
                h24: false,
                description: null,
                opening_days: [
                    { closed: true, day_of_week: 0, opening_hours: [] },
                    { closed: true, day_of_week: 1, opening_hours: [] },
                    { closed: true, day_of_week: 2, opening_hours: [] },
                    { closed: true, day_of_week: 3, opening_hours: [] },
                    { closed: true, day_of_week: 4, opening_hours: [] },
                    { closed: true, day_of_week: 5, opening_hours: [] },
                    { closed: true, day_of_week: 6, opening_hours: [] },
                ]
            }
        }
    },
    methods: {
        ...mapMutations('web_form', ['setAddOpeningPeriodDialog', 'setCurrentOpeningPeriod']),
        openModal() {
            let period = JSON.parse(JSON.stringify(this.initPeriod))

            period.uid = Math.random().toString(36).substr(2, 16)

            this.setCurrentOpeningPeriod(period)
            this.setAddOpeningPeriodDialog(true)
        }
    },
    computed: {
        ...mapState("webFormStyle", ['primaryColor']),
    }
}
</script>
